import { PayloadAction, createSlice } from '@reduxjs/toolkit';

import SivChecklistListView from 'src/components/StartUp/sivChecklist/SivChecklistListView';
import SIVChecklistPage from 'src/components/StartUp/sivChecklist/SivChecklist';

const initialState: any = {
  showCMPArr: [
    {
      cmp: SivChecklistListView,
      key: 'sivchecklistview',
      curruntlyActive: true
    },
    {
      cmp: SIVChecklistPage,
      key: 'sivchecklistpage',
      curruntlyActive: false
    }
  ],
  selectedRowData: {},
  isSivReportCopyOverrideData: true,
  isSubmitSivchecklist: false,
  disableSaveButtonProps: {
    clinicalTrialDetails: true,
    siteAdequacy: true,
    informConcent: true,
    adverseEventReporting: true,
    monitoring: true,
    requirementsforECrfcompletion: true,
    sourceDocumentation: true,
    confirm: true
  }
};

export const sivCheckList = createSlice({
  name: 'sivCheckList',
  initialState,
  reducers: {
    setChckListCMPArr: (state: any, action: PayloadAction<string>) => {
      const tempBackArr = state.showCMPArr.map((ele: any) => {
        if (ele.key === action.payload) {
          return { ...ele, curruntlyActive: true };
        }
        return { ...ele, curruntlyActive: false };
      });
      state.showCMPArr = tempBackArr;
    },
    setSelectedRowData: (state: any, action: any) => {
      state.selectedRowData = action.payload;
    },

    setIsSivReportCopyOverrideData: (state, action: PayloadAction<any>) => {
      state.isSivReportCopyOverrideData = action.payload;
    },

    setIsSubmitSivchecklist: (state, action: PayloadAction<any>) => {
      state.isSubmitSivchecklist = action.payload;
    },
    setIsSaveButtonDisable: (state, action: PayloadAction<any>) => {
      state.disableSaveButtonProps = action.payload;
    }
  }
});

export const {
  setChckListCMPArr,
  setSelectedRowData,
  setIsSivReportCopyOverrideData,
  setIsSubmitSivchecklist,
  setIsSaveButtonDisable
} = sivCheckList.actions;
